import axios from "axios";

export const newUserRequest = async (post) => {
    return await axios.post(`https://${process.env.REACT_APP_API_SERVER}/auth/local/new`, post, {
        headers: {
            "Content-Type": 'application/json',
        }
    })
}
